import { InstructorDashboardCard } from "@components/InstructorDashboard";
import { SliderCom as Slider } from "@components/Slider";
import clsx from "clsx";
import { Row, Col } from "react-bootstrap";
// import { AiOutlineAppstore } from "react-icons/ai";
// import { Slider, InstructorDashboardCard } from "../../components";
import styles from "./styles/InstructorDashboardPage.module.css";
import { LatestCourse, News } from "./Data";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  getTotalEnrollInstructorAction,
  getTotalReviewInstructorAction,
} from "@redux/actions";
// import { FiBook } from "react-icons/fi";
const InstructorDashboardPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const totalReviewInstructor = useSelector(
    (state) => state.review.getTotalReviewInstructor.data
  );

  const totalEnrollInstructor = useSelector(
    (state) => state.enrollment.getTotalEnrollInstructor.data
  );

  // effects
  useEffect(() => {
    // dispatch(getProfileAction());
    // dispatch(getMyCoursesAction());
    // dispatch(getMyPurchasesAction());
    dispatch(getTotalReviewInstructorAction());
    dispatch(getTotalEnrollInstructorAction());
  }, []);
  return (
    <>
      <div className="sa4d25" style={{ padding: "40px 30px" }}>
        <div className="container-fluid">
          <Row>
            <Col lg={12}>
              <h2 className={clsx(styles.dashboardTitle)}>
                {/* <AiOutlineAppstore />  */}
                <i className="bi bi-grid" />
                <span>Instructor Dashboard</span>
              </h2>
            </Col>
            <Col xl={3} lg={6} md={6}>
              <InstructorDashboardCard
                title="Total Student Enroll"
                values={`${totalEnrollInstructor}`}
                // addition="New $50"
                image="https://gambolthemes.net/html-items/cursus_main_demo/images/dashboard/achievement.svg"
              />
            </Col>
            <Col xl={3} lg={6} md={6}>
              <InstructorDashboardCard
                title="Total Student Feedback"
                values={`${totalReviewInstructor}`}
                // addition="New $50"
                image="https://gambolthemes.net/html-items/cursus_main_demo/images/dashboard/graduation-cap.svg"
              />
            </Col>
            {/*<Col xl={3} lg={6} md={6}>
              <InstructorDashboardCard
                title="Total Courses"
                values="$350"
                addition="New $50"
                image="https://gambolthemes.net/html-items/cursus_main_demo/images/dashboard/online-course.svg"
              />
            </Col>
            <Col xl={3} lg={6} md={6}>
              <InstructorDashboardCard
                title="Total Students"
                values="$350"
                addition="New $50"
                image="https://gambolthemes.net/html-items/cursus_main_demo/images/dashboard/knowledge.svg"
              />
            </Col>*/}
            <Col md={12}>
              <div className={clsx(styles.dashboardCard1)}>
                <div className={clsx(styles.dashboardCardLeft1)}>
                  {/* <FiBook
                    style={{
                      fontSize: "1.7rem",
                      opacity: "0.8",
                      marginRight: "1rem",
                    }}
                  /> */}
                  <h1 className="d-flex flex-row align-items-center">
                    <i className="bi bi-book" />
                    <span>Jump Into Course Creation</span>
                  </h1>
                </div>
                <div className={clsx(styles.dashboardCardRight1)}>
                  <button
                    className={clsx(styles.btnDashboardCreate)}
                    onClick={() => {
                      navigate("/create-new-course");
                    }}
                  >
                    Create Your Course
                  </button>
                </div>
              </div>
            </Col>
          </Row>
          {/* <Row>
            <Col xl={4} lg={6} md={6}>
              <div
                className={clsx(styles.section3125)}
                style={{ marginTop: "50px" }}
              >
                <Slider
                  slidesToShow={1}
                  slidesToScroll={1}
                  header="Latest Courses performance"
                  slideLength={LatestCourse.length}
                  arrows={false}
                >
                  {LatestCourse.map((value, key) => {
                    return (
                      <div className="item" key={key}>
                        <div className={clsx(styles.courseMain)}>
                          <a href="/#" className={clsx(styles.courseImg)}>
                            <img
                              className={clsx(styles.imagePreview)}
                              src={value.imagePreview}
                              alt=""
                            />
                          </a>
                          <div className={clsx(styles.courseContent)}>
                            <div className={clsx(styles.vdtodt)}>
                              <span className={clsx(styles.vdt14)}>
                                {value.vodt}
                              </span>
                            </div>
                            <a href="/#" className={clsx(styles.crsedt145)}>
                              {value.content}
                            </a>
                            <div className={clsx(styles.allvperf)}>
                              <div className={clsx(styles.crsePerfLeft)}>
                                View
                              </div>
                              <div className={clsx(styles.crsePerfRight)}>
                                {value.view}
                              </div>
                            </div>
                            <div className={clsx(styles.allvperf)}>
                              <div className={clsx(styles.crsePerfLeft)}>
                                Purchased
                              </div>
                              <div className={clsx(styles.crsePerfRight)}>
                                {value.purchased}
                              </div>
                            </div>
                            <div className={clsx(styles.allvperf)}>
                              <div className={clsx(styles.crsePerfLeft)}>
                                Total Like
                              </div>
                              <div className={clsx(styles.crsePerfRight)}>
                                {value.totalLike}
                              </div>
                            </div>
                            <div className={clsx(styles.authorLinkPirce)}>
                              <a href="/#" className={clsx(styles.cr1fot50)}>
                                Go to course analytics
                              </a>
                              <a href="/#" className={clsx(styles.cr1fot50)}>
                                See comments (875)
                              </a>
                              <a href="/#" className={clsx(styles.cr1fot50)}>
                                See Reviews (105)
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </Slider>
              </div>
            </Col>
            <Col xl={4} lg={6} md={6}>
              <div
                className={clsx(styles.section3125)}
                style={{ marginTop: "50px" }}
              >
                <Slider
                  slidesToShow={1}
                  slidesToScroll={1}
                  header="News"
                  slideLength={News.length}
                  arrows={false}
                >
                  {News.map((value, key) => {
                    return (
                      <div className={clsx(styles.item)} key={key}>
                        <div className={clsx(styles.courseMain)}>
                          <a href="/#" className={clsx(styles.courseImg)}>
                            <img
                              className={clsx(styles.imagePreview)}
                              src={value.imagePreview}
                              alt=""
                            />
                          </a>
                          <div className={styles.courseContent}>
                            <a
                              href="/#"
                              className={styles.crsedt145}
                              style={{ marginTop: "15px" }}
                            >
                              {value.header}
                            </a>
                            <p className={styles.news_des45}>{value.content}</p>
                            <div className={clsx(styles.authorLinkPirce)}>
                              <a href="/#" className={clsx(styles.cr1fot50)}>
                                Learn More
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </Slider>
              </div>
            </Col>
            <Col xl={4} lg={6} md={6}>
              <div className={styles.section3125} style={{ marginTop: "50px" }}>
                <h4 className={styles.itemTitle}>Profile Analytics</h4>
                <div className={styles.la5lo1}>
                  <div className={styles.courseMain}>
                    <div className={styles.courseContent}>
                      <h6 className={styles.crsedt8145}>Current subscribers</h6>
                      <h3 className={styles.subcribeTitle}>856</h3>
                      <div className={clsx(styles.allvperf)}>
                        <div className={clsx(styles.crsePerfLeft)}>View</div>
                        <div className={clsx(styles.crsePerfRight)}>
                          17k
                          <span className={styles.analyics_pr}>
                            <i className="uil uil-arrow-to-bottom"></i>75%
                          </span>
                        </div>
                      </div>
                      <div className={clsx(styles.allvperf)}>
                        <div className={clsx(styles.crsePerfLeft)}>
                          Purchased
                          <span className={clsx(styles.perText)}>
                            (per hour)
                          </span>
                        </div>
                        <div className={clsx(styles.crsePerfRight)}>
                          1
                          <span className={clsx(styles.analyicsPr)}>
                            <i className="uil uil-top-arrow-from-top"></i>100%
                          </span>
                        </div>
                      </div>
                      <div className={clsx(styles.allvperf)}>
                        <div className={clsx(styles.crsePerfLeft)}>
                          Enroll
                          <span className={clsx(styles.per_text)}>
                            (per hour)
                          </span>
                        </div>
                        <div className={clsx(styles.crsePerfRight)}>
                          50
                          <span className={styles.analyicsPr}>
                            <i className="uil uil-top-arrow-from-top"></i>70%
                          </span>
                        </div>
                      </div>
                      <div className={clsx(styles.authorLinkPirce)}>
                        <a href="/#" className={clsx(styles.cr1fot50)}>
                          Go to profile analytics
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.section3125} style={{ marginTop: "50px" }}>
                <h4 className={styles.itemTitle}>Submit Courses</h4>
                <div className={styles.la5lo1}>
                  <div className={styles.courseMain}>
                    <div className={styles.courseContent}>
                      <div className={styles.upcming_card}>
                        <div className={styles.crsedt145Container}>
                          <span className={styles.crsedt145}>
                            The Complete JavaScript Course 2020: Build Real
                            Projects!
                          </span>
                          <span className={styles.pndng145}>Pending</span>
                        </div>
                        <p className={styles.submitCourse}>
                          Submitted<span>1 days ago</span>
                        </p>
                        <a href="/#" className={styles.deleteLink10}>
                          Delete
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className={styles.section3125} style={{ marginTop: "50px" }}>
                <h4 className={styles.itemTitle}>Whats new in Edututs+</h4>
                <div className={styles.la5lo1}>
                  <div className={styles.courseMain}>
                    <div className={styles.courseContent}>
                      <span className={styles.newLinks10}>
                        Improved performance on Studio Dashboard
                      </span>
                      <span className={styles.newLinks10}>
                        See more Dashboard updates
                      </span>
                      <span className={styles.newLinks10}>
                        See issues-at-glance for Live
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row> */}
        </div>
      </div>
    </>
  );
};

export { InstructorDashboardPage };
